@file:OptIn(InternalResourceApi::class)

package com.nonopn.skywatcher.design.res

import kotlin.OptIn
import kotlin.String
import kotlin.collections.MutableMap
import org.jetbrains.compose.resources.InternalResourceApi
import org.jetbrains.compose.resources.LanguageQualifier
import org.jetbrains.compose.resources.ResourceContentHash
import org.jetbrains.compose.resources.ResourceItem
import org.jetbrains.compose.resources.StringResource

private const val MD: String = "composeResources/com.nonopn.skywatcher.design.res/"

@delegate:ResourceContentHash(-1_865_158_312)
public val Res.string.april: StringResource by lazy {
      StringResource("string:april", "april", setOf(
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/date.commonMain.cvr", 10, 21),
        ResourceItem(setOf(), "${MD}values/date.commonMain.cvr", 10, 21),
      ))
    }

@delegate:ResourceContentHash(241_575_792)
public val Res.string.august: StringResource by lazy {
      StringResource("string:august", "august", setOf(
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/date.commonMain.cvr", 32, 22),
        ResourceItem(setOf(), "${MD}values/date.commonMain.cvr", 32, 22),
      ))
    }

@delegate:ResourceContentHash(1_314_784_965)
public val Res.string.cancel: StringResource by lazy {
      StringResource("string:cancel", "cancel", setOf(
        ResourceItem(setOf(LanguageQualifier("es"), ), "${MD}values-es/strings.commonMain.cvr", 10, 26),
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 10, 26),
        ResourceItem(setOf(LanguageQualifier("pt"), ), "${MD}values-pt/strings.commonMain.cvr", 10, 26),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 10, 22),
      ))
    }

@delegate:ResourceContentHash(320_442_199)
public val Res.string.confirm: StringResource by lazy {
      StringResource("string:confirm", "confirm", setOf(
        ResourceItem(setOf(LanguageQualifier("es"), ), "${MD}values-es/strings.commonMain.cvr", 37, 27),
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 37, 27),
        ResourceItem(setOf(LanguageQualifier("pt"), ), "${MD}values-pt/strings.commonMain.cvr", 37, 27),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 33, 27),
      ))
    }

@delegate:ResourceContentHash(78_479_176)
public val Res.string.date_day_of_week_format: StringResource by lazy {
      StringResource("string:date_day_of_week_format", "date_day_of_week_format", setOf(
        ResourceItem(setOf(), "${MD}values/date.commonMain.cvr", 55, 55),
      ))
    }

@delegate:ResourceContentHash(-404_887_415)
public val Res.string.day_of_week0: StringResource by lazy {
      StringResource("string:day_of_week0", "day_of_week0", setOf(
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/date.commonMain.cvr", 55, 28),
        ResourceItem(setOf(), "${MD}values/date.commonMain.cvr", 111, 28),
      ))
    }

@delegate:ResourceContentHash(1_693_191_236)
public val Res.string.day_of_week1: StringResource by lazy {
      StringResource("string:day_of_week1", "day_of_week1", setOf(
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/date.commonMain.cvr", 84, 28),
        ResourceItem(setOf(), "${MD}values/date.commonMain.cvr", 140, 32),
      ))
    }

@delegate:ResourceContentHash(955_794_299)
public val Res.string.day_of_week2: StringResource by lazy {
      StringResource("string:day_of_week2", "day_of_week2", setOf(
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/date.commonMain.cvr", 113, 32),
        ResourceItem(setOf(), "${MD}values/date.commonMain.cvr", 173, 32),
      ))
    }

@delegate:ResourceContentHash(1_565_482_655)
public val Res.string.day_of_week3: StringResource by lazy {
      StringResource("string:day_of_week3", "day_of_week3", setOf(
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/date.commonMain.cvr", 146, 28),
        ResourceItem(setOf(), "${MD}values/date.commonMain.cvr", 206, 32),
      ))
    }

@delegate:ResourceContentHash(-167_289_639)
public val Res.string.day_of_week4: StringResource by lazy {
      StringResource("string:day_of_week4", "day_of_week4", setOf(
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/date.commonMain.cvr", 175, 32),
        ResourceItem(setOf(), "${MD}values/date.commonMain.cvr", 239, 28),
      ))
    }

@delegate:ResourceContentHash(1_236_647_815)
public val Res.string.day_of_week5: StringResource by lazy {
      StringResource("string:day_of_week5", "day_of_week5", setOf(
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/date.commonMain.cvr", 208, 28),
        ResourceItem(setOf(), "${MD}values/date.commonMain.cvr", 268, 32),
      ))
    }

@delegate:ResourceContentHash(844_239_931)
public val Res.string.day_of_week6: StringResource by lazy {
      StringResource("string:day_of_week6", "day_of_week6", setOf(
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/date.commonMain.cvr", 237, 32),
        ResourceItem(setOf(), "${MD}values/date.commonMain.cvr", 301, 28),
      ))
    }

@delegate:ResourceContentHash(-7_211_066)
public val Res.string.december: StringResource by lazy {
      StringResource("string:december", "december", setOf(
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/date.commonMain.cvr", 270, 28),
        ResourceItem(setOf(), "${MD}values/date.commonMain.cvr", 330, 28),
      ))
    }

@delegate:ResourceContentHash(1_031_480_131)
public val Res.string.end_date_label: StringResource by lazy {
      StringResource("string:end_date_label", "end_date_label", setOf(
        ResourceItem(setOf(LanguageQualifier("es"), ), "${MD}values-es/strings.commonMain.cvr", 65, 38),
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 65, 38),
        ResourceItem(setOf(LanguageQualifier("pt"), ), "${MD}values-pt/strings.commonMain.cvr", 65, 38),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 61, 34),
      ))
    }

@delegate:ResourceContentHash(-2_039_523_484)
public val Res.string.february: StringResource by lazy {
      StringResource("string:february", "february", setOf(
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/date.commonMain.cvr", 299, 28),
        ResourceItem(setOf(), "${MD}values/date.commonMain.cvr", 359, 28),
      ))
    }

@delegate:ResourceContentHash(-1_414_115_515)
public val Res.string.january: StringResource by lazy {
      StringResource("string:january", "january", setOf(
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/date.commonMain.cvr", 328, 27),
        ResourceItem(setOf(), "${MD}values/date.commonMain.cvr", 388, 27),
      ))
    }

@delegate:ResourceContentHash(-1_518_998_151)
public val Res.string.july: StringResource by lazy {
      StringResource("string:july", "july", setOf(
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/date.commonMain.cvr", 356, 24),
        ResourceItem(setOf(), "${MD}values/date.commonMain.cvr", 416, 20),
      ))
    }

@delegate:ResourceContentHash(1_095_194_423)
public val Res.string.june: StringResource by lazy {
      StringResource("string:june", "june", setOf(
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/date.commonMain.cvr", 381, 20),
        ResourceItem(setOf(), "${MD}values/date.commonMain.cvr", 437, 20),
      ))
    }

@delegate:ResourceContentHash(-847_655_013)
public val Res.string.march: StringResource by lazy {
      StringResource("string:march", "march", setOf(
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/date.commonMain.cvr", 402, 21),
        ResourceItem(setOf(), "${MD}values/date.commonMain.cvr", 458, 21),
      ))
    }

@delegate:ResourceContentHash(82_826_597)
public val Res.string.may: StringResource by lazy {
      StringResource("string:may", "may", setOf(
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/date.commonMain.cvr", 424, 15),
        ResourceItem(setOf(), "${MD}values/date.commonMain.cvr", 480, 15),
      ))
    }

@delegate:ResourceContentHash(-877_113_472)
public val Res.string.november: StringResource by lazy {
      StringResource("string:november", "november", setOf(
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/date.commonMain.cvr", 440, 28),
        ResourceItem(setOf(), "${MD}values/date.commonMain.cvr", 496, 28),
      ))
    }

@delegate:ResourceContentHash(-1_926_288_608)
public val Res.string.october: StringResource by lazy {
      StringResource("string:october", "october", setOf(
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/date.commonMain.cvr", 469, 27),
        ResourceItem(setOf(), "${MD}values/date.commonMain.cvr", 525, 27),
      ))
    }

@delegate:ResourceContentHash(1_441_045_129)
public val Res.string.period_label: StringResource by lazy {
      StringResource("string:period_label", "period_label", setOf(
        ResourceItem(setOf(LanguageQualifier("es"), ), "${MD}values-es/strings.commonMain.cvr", 104, 32),
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 104, 32),
        ResourceItem(setOf(LanguageQualifier("pt"), ), "${MD}values-pt/strings.commonMain.cvr", 104, 32),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 96, 28),
      ))
    }

@delegate:ResourceContentHash(134_032_512)
public val Res.string.september: StringResource by lazy {
      StringResource("string:september", "september", setOf(
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/date.commonMain.cvr", 497, 29),
        ResourceItem(setOf(), "${MD}values/date.commonMain.cvr", 553, 29),
      ))
    }

@delegate:ResourceContentHash(-436_875_320)
public val Res.string.single_date_label: StringResource by lazy {
      StringResource("string:single_date_label", "single_date_label", setOf(
        ResourceItem(setOf(LanguageQualifier("es"), ), "${MD}values-es/strings.commonMain.cvr", 137, 33),
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 137, 33),
        ResourceItem(setOf(LanguageQualifier("pt"), ), "${MD}values-pt/strings.commonMain.cvr", 137, 33),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 125, 33),
      ))
    }

@delegate:ResourceContentHash(1_287_134_070)
public val Res.string.start_date_label: StringResource by lazy {
      StringResource("string:start_date_label", "start_date_label", setOf(
        ResourceItem(setOf(LanguageQualifier("es"), ), "${MD}values-es/strings.commonMain.cvr", 171, 44),
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 171, 44),
        ResourceItem(setOf(LanguageQualifier("pt"), ), "${MD}values-pt/strings.commonMain.cvr", 171, 44),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 159, 40),
      ))
    }

@delegate:ResourceContentHash(1_006_713_488)
public val Res.string.today_label: StringResource by lazy {
      StringResource("string:today_label", "today_label", setOf(
        ResourceItem(setOf(LanguageQualifier("es"), ), "${MD}values-es/strings.commonMain.cvr", 216, 23),
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 216, 35),
        ResourceItem(setOf(LanguageQualifier("pt"), ), "${MD}values-pt/strings.commonMain.cvr", 216, 27),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 200, 27),
      ))
    }

@delegate:ResourceContentHash(1_048_070_443)
public val Res.string.validate: StringResource by lazy {
      StringResource("string:validate", "validate", setOf(
        ResourceItem(setOf(LanguageQualifier("es"), ), "${MD}values-es/strings.commonMain.cvr", 240, 28),
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 252, 28),
        ResourceItem(setOf(LanguageQualifier("pt"), ), "${MD}values-pt/strings.commonMain.cvr", 244, 28),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 228, 28),
      ))
    }

@InternalResourceApi
internal fun _collectCommonMainString0Resources(map: MutableMap<String, StringResource>) {
  map.put("april", Res.string.april)
  map.put("august", Res.string.august)
  map.put("cancel", Res.string.cancel)
  map.put("confirm", Res.string.confirm)
  map.put("date_day_of_week_format", Res.string.date_day_of_week_format)
  map.put("day_of_week0", Res.string.day_of_week0)
  map.put("day_of_week1", Res.string.day_of_week1)
  map.put("day_of_week2", Res.string.day_of_week2)
  map.put("day_of_week3", Res.string.day_of_week3)
  map.put("day_of_week4", Res.string.day_of_week4)
  map.put("day_of_week5", Res.string.day_of_week5)
  map.put("day_of_week6", Res.string.day_of_week6)
  map.put("december", Res.string.december)
  map.put("end_date_label", Res.string.end_date_label)
  map.put("february", Res.string.february)
  map.put("january", Res.string.january)
  map.put("july", Res.string.july)
  map.put("june", Res.string.june)
  map.put("march", Res.string.march)
  map.put("may", Res.string.may)
  map.put("november", Res.string.november)
  map.put("october", Res.string.october)
  map.put("period_label", Res.string.period_label)
  map.put("september", Res.string.september)
  map.put("single_date_label", Res.string.single_date_label)
  map.put("start_date_label", Res.string.start_date_label)
  map.put("today_label", Res.string.today_label)
  map.put("validate", Res.string.validate)
}
